import React, { useEffect } from "react";
import NavComponent from "../../../components/NavComponent";
import "./FleetManagement.css";
import Aos from "aos";
import { Link } from "react-router-dom";
import { Features, fleetBenefits } from "../../../Data/FleetManagementData";
import FAQ from "../../../components/FAQ";
import SEOHelmet from "../../../components/SEOHelmet";
import { FleetManagement_SEO } from "../../../Data/SEO-JsonData";
import { FleetManagement_faq } from "../../../Data/FAQdata";

const FleetManagement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    Aos.init({
      duration: 1500,
    });
  }, []);
  return (
    <>
      <SEOHelmet
        title="Fleet Management Software | Real-Time GPS Tracking & Fleet Optimization"
        description="Simplify your fleet operations with Canvendor’s fleet management software. Enjoy real-time GPS tracking, fuel optimization, driver monitoring, and maintenance alerts — all designed to reduce costs and boost efficiency."
        keywords="Fleet management software, GPS vehicle tracking, Fleet tracking system, Fleet maintenance software, Fleet telematics platform, Driver monitoring system, Fuel management software, Fleet optimization software"
        url="https://www.canvendor.com/industries/fleetManagement"
        image="https://www.canvendor.com/IndustryImages/bannerImg.png"
        alt="Fleet Management - Canvendor"
        jsonLd={FleetManagement_SEO}
      />
      <div className="FleetManagement">
        <NavComponent></NavComponent>
        <div className="FleetManagement_Title_container">
          <div className="fm-title-content" data-aos="fade-up">
            <h1 className="fm-title">
              Drive Smarter.
              <br />
              Manage Better. Save More.
            </h1>
            <h5 className="fm-subtitle">Canvendor Fleet Management Solution</h5>
            <div className="line_Container">
              <div className="line1"></div>
              <div className="line2"></div>
            </div>
            <div className="page-direction" data-aos="fade-up">
              <span className="ps-0">
                <Link to="/">Home</Link>
              </span>
              <span>
                <Link to="/services">Industries</Link>
              </span>
              <p>Supply Chain and Logistics</p>
            </div>
            <p className="fm-title-desc" data-aos="fade-up">
              Your fleet isn't just a collection of vehicles it's the heartbeat
              of your business. But managing it efficiently and securely? That's
              the real challenge. With Canvendor Fleet Management Solution, a
              leading fleet management software and vehicle tracking system, you
              gain real-time visibility and complete control over your
              operations. Unlock operational efficiency, enhance driver safety,
              ensure compliance, and cut fleet costs from the office to the open
              road so you can focus on growing your business.
            </p>

            {/* <Link to="/contactUs">
              <button className="getInTouch_Btn" data-aos="fade-right">
                Get in Touch
              </button>
            </Link> */}
            <Link to="/contactUs">
              <button className="btn explore-btn" data-aos="fade-up">
                Get in Touch
                <img
                  className="explore-arrow"
                  src="/explore-arrow.png"
                  alt="#"
                />
              </button>
            </Link>
          </div>
        </div>

        {/* software section */}
        <div className="fm-software-sec">
          <div className="fm-software-innerCon">
            <span class="sub-title">What Is Fleet Management Software?</span>
            <div className="fm-software-flexCon">
              <div className="fm-software-content">
                <p>
                  Fleet management is about more than just keeping trucks on the
                  road. It involves:
                </p>
                <ul>
                  <li>
                    Ensuring driver safety with proactive driver monitoring
                    system tools
                  </li>
                  <li>
                    Staying compliant with industry standards using fleet
                    compliance software
                  </li>
                  <li>
                    Preventing unexpected downtime through timely fleet
                    maintenance software
                  </li>
                  <li>
                    Reducing operating costs mile after mile with advanced fleet
                    optimization software
                  </li>
                </ul>
                <p>
                  Canvendor’s advanced fleet telematics platform provides
                  actionable insights and automated tools to help you run a
                  safe, efficient, and compliant fleet without the guesswork.
                </p>
              </div>
              <div className="fm-right-img">
                <div className="conLeft" data-aos="fade-up">
                  <div className="imgCon">
                    <img
                      src="/IndustryImages/fleet1.png"
                      alt="fleetManagment"
                    />
                  </div>
                  <div className="bgGradient"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="fm-features">
          <div className="fm-features-innerCon">
            <span class="sub-title">
              Powerful Features of Canvendor Fleet Tracking Solution
            </span>
            <div className="fm-features-content">
              {Features.map((item, index) => {
                return (
                  <div key={index} className="fm-features-item">
                    <h5 className="fm-featrues-title">{item.title}</h5>
                    <p className="fm-featrues-desc">{item.description}</p>
                    <div className="fm-features-icon">
                      <img src={item.icon} alt={item.alt} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Business choose */}
        <div className="fm-Business-sec">
          <div className="fm-Business-innerCon">
            <span class="sub-title">Why Businesses Choose Canvendor</span>
            <div className="fm-Business-content-con">
              <div className="fm-benefits-container">
                {fleetBenefits.map((benefit, index) => (
                  <div className="fm-benefit-card" key={index}>
                    <img src={benefit.icon} alt={benefit.alt} />
                    <div>
                      <h3>{benefit.title}</h3>
                      <p>{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="fm-right-img">
                <div className="imgCon" data-aos="fade-up">
                  <img src="/IndustryImages/business.png" alt="softwareImg" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Advantages */}
        <section className="fm-advantage-sec">
          <div className="fm-container">
            <div className="fm-images-section">
              <div className="fm-image-card">
                <img
                  src="/IndustryImages/benefitImg.png"
                  alt="Checkmark Tech"
                />
              </div>
            </div>

            <div className="fm-content-section">
              <div className="fm-text-block">
                <span class="sub-title">The Canvendor Advantage</span>
                <p className="fm-paragraph">
                  Our scalable fleet management solution for small businesses
                  and enterprises alike fits fleets from 10 to 1,000+ vehicles.
                  Our easy-to-use dashboard ensures no steep learning curve, and
                  our expert support team is available 24/7.
                </p>
                <p className="fm-paragraph">
                  Whether you're managing a handful of vehicles or running a
                  nationwide operation, our fleet telematics platform keeps you
                  in control.
                </p>
              </div>

              <div className="fm-cta-block">
                <span class="sub-title">
                  Ready to Take Control of Your Fleet?
                </span>

                <p className="fm-paragraph">
                  Request your personalized fleet management software demo today
                  and see how Canvendor can make your fleet smarter, safer, and
                  more cost-efficient.
                </p>
              </div>
            </div>
          </div>
        </section>

        <FAQ data={FleetManagement_faq} />
      </div>
    </>
  );
};

export default FleetManagement;
